import React from 'react';

const CityComparison = () => {
  return (
    <div>
      <h1>City Comparison</h1>
      <p>Compare two cities here...</p>
    </div>
  );
};

export default CityComparison;
